import React from 'react';
import { connect } from 'react-redux';
import { Grid } from 'semantic-ui-react';
import DatasetDictionary from '../dictionaries/containers/DatasetDictionary';
import CatalogueTitle from '../catalogue/components/CatalogueTitle';
import DatasetPanelContainer, {
  mapDispatchToProps,
  mapStateToProps,
} from '../components/DatasetPanelContainer';
import DatasetSubscribeAction from '../subscriptions/components/DatasetSubscribeAction';
import DatasetVisibilityLabel from '../components/DatasetVisibilityLabel';
import DatasetCatalogueAccordion from '../catalogue/components/DatasetCatalogueAccordion';
import DatasetAttachmentsCards from '../attachments/components/DatasetAttachmentsCards';

const DatasetPanelNarrow = ({
  allowManage,
  asViewer,
  canCreate,
  canRead,
  canReadAttachments,
  canSubscribe,
  category,
  code,
  datasetUrl,
  exists,
  fetchData,
  isDirty,
  isNew,
  wizardOn,
  name,
  newDataset,
  onChange,
  readErrors,
  readStatus,
  saveErrors,
  templateReadStatus,
  url,
  updateProperties,
  visibility,
}) => (
  <DatasetPanelContainer
    asViewer={asViewer}
    canCreate={canCreate}
    canRead={canRead}
    category={category}
    className="aridhia-dataset-panel-narrow overflow-x-hidden panel-wizardible"
    code={code}
    compact
    datasetUrl={datasetUrl}
    exists={exists}
    fetchData={fetchData}
    isDirty={isDirty}
    wizardOn={wizardOn}
    isNew={isNew}
    name={name}
    newDataset={newDataset}
    onChange={onChange}
    readErrors={readErrors}
    readStatus={readStatus}
    saveErrors={saveErrors}
    templateReadStatus={templateReadStatus}
    updateProperties={updateProperties}
    url={datasetUrl}
  >
    <Grid>
      <Grid.Row>
        <Grid.Column width={isNew ? 16 : 10}>
          <CatalogueTitle code={code} category={category} errorCoordinate="t-45" isNew={isNew} />
        </Grid.Column>
        {!isNew && (
        <Grid.Column width={6} textAlign="right">
          <DatasetVisibilityLabel visibility={visibility} code={code} allowManage={allowManage} />
          {canSubscribe && <DatasetSubscribeAction code={code} category={category} />}
        </Grid.Column>
        )}
      </Grid.Row>
    </Grid>
    <DatasetCatalogueAccordion category={category} code={code} url={url} isNew={isNew}>
      {canReadAttachments && <DatasetAttachmentsCards code={code} category={category} compact />}
    </DatasetCatalogueAccordion>
    <DatasetDictionary code={code} category={category} compact />
  </DatasetPanelContainer>
);

export default connect(mapStateToProps, mapDispatchToProps)(DatasetPanelNarrow);
